import React,{useEffect,useState} from 'react';
import { Col, Row } from "react-bootstrap";
import Img from 'gatsby-image';
import ImgBox from '@components/img-box/img-box'
import MemberForm from "@components/forms/member-form"
import Modal from 'react-bootstrap/Modal'
import { Envelop, Phone } from '@components/icon/icon';

/**
 * Assets
 */

import './styles/_index.scss';

const NewsContactBox = ({ phone, link, email, name, position, type}) => {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [teamid, setteamid] = useState(false);

  const handleShow = (event) => {
    setteamid(event);
    setShow(true);
}


    return (
        <div className="contact-box">           
                    <>
                    {/* <h5 className='contact-box-text'>Do you have a property to {type ? type : "Sell"}?</h5> */}
                    <h5 className='contact-box-text'>Do you have a property to Sell?</h5>
                    <p className='text-20'>Speak with one of our team today and start your journey with Anthony Pepe.</p>                      

                      <>                        
                        <div className="links">
                            {phone && 
                            <>
                            <a className='text-20 btn btn' href={`tel:${phone}`}><Phone /> {phone}</a>
                            </>
                            }      
                            <a className='text-20 btn btn' href="javascript:;" onClick={ () => handleShow(email)}> <Envelop /> Book a valuation</a>
                        </div>
                      </>
                      
                            <Modal
                            show={show}
                            centered={true}
                            onHide={handleClose}
                            backdrop="static"
                            keyboard={false}
                            dialogClassName="modal-90w modal-form">

                            <Modal.Header closeButton className="contact-close-btn memberPopup">
                            <Modal.Title className="w-100 ">{name ? `CONTACT - ${name}` : "CONTACT"}
                            </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                            <MemberForm to_email_id={email} formName={`Contact Person`} />
                            </Modal.Body>
                            </Modal>
                        </>              
        </div>
    )
}

export default NewsContactBox;
